module.exports = __webpack_public_path__ + "static/media/yahoo.4913eb5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/yahoo.svg
// module id = 212
// module chunks = 0